import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import clsx from 'clsx'

export default function TextTwoColumn({
	heading,
	_rawRichtext,
	style,
	lineColor = 'teal',
	hideLines,
}) {
	const styleClass =
		style === 'grounding-navy'
			? 'bg-grounding-navy text-caribbean'
			: style === 'light-blue'
				? 'bg-light-blue'
				: style === 'caribbean'
					? 'bg-caribbean'
					: null

	return (
		<section
			className={clsx(
				styleClass,
				'overflow-hidden lg:py-16',
				lineColor === 'orange' && '[--line-color:#ed571c]',
			)}
		>
			<div
				data-aos="fade-left"
				className="section grid md:grid-cols-2 lg:gap-[70px]"
			>
				<HTag
					className={clsx('h1 mb-4 lg:mb-0', !hideLines && 'lg:header-line')}
					{...heading}
				/>
				<Richtext className={clsx(styleClass, 'richtext')} raw={_rawRichtext} />
			</div>
		</section>
	)
}
